import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rate_limit_empty"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "rate_limit_text" }
const _hoisted_4 = {
  key: 10,
  class: "community_wrapper"
}

import { ref, watch, onActivated, onMounted, getCurrentInstance, ComponentInternalInstance, reactive } from 'vue'
import { List, Loading } from 'vant'
import { storeToRefs } from 'pinia'
import 'swiper/css'
import 'swiper/css/autoplay'
import HomeHeader from './HomeHeader.vue'
import Banner from './Banner.vue'
import Menu from './Menu.vue'
import Course from './Course.vue'
import Announcement from './Announcement.vue'
import TodoList from './TodoList.vue'
import LiveStream from './LiveStream.vue'
import Broadcast from './Broadcast.vue'
import BroadcastAndCourse from './BroadcastAndCourse.vue'
import Popularize from './Popularize.vue'
import Instructor from './Instructor.vue'
import { useThemeColorWithAlpha } from '@/utils/theme'
import { postCollegeList, postHomeConfig } from '@/api/requests/HomeRequests'
import { CollegeDetail, LmsDecorateModule } from '@/api/Models/HomeConfig'
import CardTitle from './CardTitle.vue'
import { Record as CommunityRecord } from '@/api/Models/CommunityBoardContentList'
import ArticleCard from '@/views/community/components/ArticleCard.vue'
import APIRequest from '@/api'
import { useUsersStore } from '@/stores/users'
import { useAuthStore } from '@/stores/login'
import { useSystemStore } from '@/stores/system'
import { College } from '@/api/Models/CollegeList'
import Advertise from '@/views/home/Advertise.vue'
import { Record as AdvertiseRecord } from '@/api/Models/HomeAdvertiseList'

import BackTop from '@/components/BackTop.vue'
import { useCookieConsent } from '@/composables/useCookieConsent'
import { Attachment } from '@/api/Models/Attachment'
import ImgPreview from '@/components/ImgPreview.vue'
import PullToRefresh from '@/components/PullToRefresh.vue'


const __default__ = {
  name: 'tab'
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

_useCssVars(_ctx => ({
  "v96f1fe98": (_unref(themeColorWithAlpha))
}))

const rateLimited = ref(false)
const rateLimitImg = require('@/assets/images/empty/error.png')

const badgeNum = ref(0)
const getNum = async () => {
  const { data, code } = await APIRequest.MyLearning.getMyLearningTask({
    taskStatus: 100,
    size: 5,
    current: 1
  })
  if (code === 1) {
    badgeNum.value = data.total
  }
}
onActivated(() => {
  getNum()
})
onMounted(() => {
  getNum()
})

const imageList = ref<string[]>([] as string[])
const previewShow = ref(false)
const previewIndex = ref(0)
const showPreview = (data: { attachments: Attachment[]; index: number }) => {
  imageList.value = data?.attachments.map((item) => item.previewUrl || '')
  previewShow.value = true
  previewIndex.value = data.index
}
const handleClose = () => {
  previewShow.value = false
}

const advertiseList = ref<AdvertiseRecord[]>([])
const advertiseShow = ref(false)

const getAdvertise = async () => {
  // 优化：广告一天内只弹一次
  const now = new Date()
  const today = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`
  const lastAdvertiseDate = localStorage.getItem('lastAdvertiseDate')

  if (lastAdvertiseDate === today) {
    localStorage.removeItem('fromLogin')
    return
  }

  console.log('开始调用广告接口')
  const { code, data } = await APIRequest.Home.getHomeAdvertiseList({
    location: '0',
    current: 1,
    size: 4
  })

  console.log('广告接口返回:', { code, data })

  if (code === 1) {
    // 修改过滤逻辑，去除空格并检查URL有效性
    const records = (data.records || []).filter((e) => {
      const trimmedUrl = e.appImgUrl?.trim()
      return trimmedUrl && trimmedUrl.length > 0
    })

    console.log('过滤后的records:', records, 'length:', records.length)
    console.log('第一条数据的appImgUrl:', records[0]?.appImgUrl)

    if (records.length > 0) {
      // 清理URL中的空格
      const cleanedRecords = records.map((record) => ({
        ...record,
        appImgUrl: record.appImgUrl?.trim()
      }))

      // 先设置数据
      advertiseList.value = cleanedRecords
      console.log('广告数据已设置:', advertiseList.value)

      // 使用延迟确保页面完全加载后再显示弹窗
      advertiseShow.value = true
      // 记录今日已展示
      localStorage.setItem('lastAdvertiseDate', today)
    }
    localStorage.removeItem('fromLogin')
  } else {
    console.log('接口调用失败，code:', code)
    // 接口失败时也重置状态
    advertiseList.value = []
    advertiseShow.value = false
  }
}

const loading = ref(false)
const finished = ref(true)
const refreshing = ref(false)
let current = 2
let feedCommunitySort = 0
let feedCommunityBoardIds: number[] = []
let feedCommunityModuleId = ''
const communityDataMap = reactive<Record<string, CommunityRecord[]>>({})

const getCommunityArticleData = (item: LmsDecorateModule): CommunityRecord[] => {
  const list = communityDataMap[item.id] || []
  if (item.isFeedStream !== 1) {
    const maxCount = Number(item.dataMaxCount) || 0
    return maxCount > 0 ? list.slice(0, maxCount) : list
  }
  return list
}

const resetCommunityState = () => {
  current = 2
  feedCommunitySort = 0
  feedCommunityBoardIds = []
  feedCommunityModuleId = ''
  Object.keys(communityDataMap).forEach((key) => {
    delete communityDataMap[key]
  })
}

const onLoad = async () => {
  if (rateLimited.value) return
  if (!feedCommunityModuleId) {
    loading.value = false
    finished.value = true
    return
  }
  if (refreshing.value) {
    communityDataMap[feedCommunityModuleId] = []
    refreshing.value = false
  }
  const { code, data } = await APIRequest.Community.getCommunityBoardContentList({
    current,
    size: 12,
    sortType: (feedCommunitySort + 1).toString(),
    boardIds: feedCommunityBoardIds
  })
  loading.value = false
  if (code === 1) {
    console.log(data)
    if (!data.records || data.records.length === 0) {
      finished.value = true
    }
    current++
    if (!communityDataMap[feedCommunityModuleId]) {
      communityDataMap[feedCommunityModuleId] = []
    }
    communityDataMap[feedCommunityModuleId].push(...data.records)
  } else {
    finished.value = true
  }
}

const { proxy } = getCurrentInstance() as ComponentInternalInstance
proxy?.$bus.on('thumbup', ({ id, likeCount, isLike }: { id: string; likeCount: number; isLike: boolean }) => {
  Object.values(communityDataMap).some((list) => {
    const cur = list.find((item) => item.id === id)
    if (!cur) return false
    cur.isLike = isLike
    cur.likeCount = Number(likeCount)
    return true
  })
})

const setRateLimited = (value: boolean) => {
  rateLimited.value = value
  if (!value) return
  loading.value = false
  finished.value = true
  refreshing.value = false
  modules.value = []
  resetCommunityState()
  advertiseShow.value = false
  advertiseList.value = []
}

proxy?.$bus.on('home_rate_limited', () => {
  setRateLimited(true)
})

const usersStore = useUsersStore()
const { collegeId } = storeToRefs(usersStore)
const collegeIdCache = ref(collegeId.value)
const setCollegeIdCache = (id: string) => {
  collegeIdCache.value = id
}
const { setCollegeId } = usersStore
const onRefresh = (loadingType?: '0' | '1') => {
  if (rateLimited.value) return
  current = 2
  init(loadingType)
}

const collegeDetail = ref({} as CollegeDetail)
const modules = ref([] as LmsDecorateModule[])

const init = async (type?: '0' | '1') => {
  if (rateLimited.value) return
  finished.value = true
  resetCommunityState()
  const res = await postHomeConfig(
    {
      clientType: 3,
      collegeId: collegeIdCache.value,
      readCache: 0,
      switchCollege: 1,
      templateId: ''
    },
    type
  )
  // console.log(res)
  const { code, data } = res
  refreshing.value = false
  if (code === 429) {
    setRateLimited(true)
    return
  }
  if (code === 1) {
    setCollegeId(collegeIdCache.value)
    collegeDetail.value = data.collegeDetail
    modules.value = data.lmsDecorateModules
    for (let i = 0; i < data.lmsDecorateModules.length; i++) {
      const item = data.lmsDecorateModules[i]
      if (item.code === 'app-community') {
        const lmsDecorateModuleCategories = item.lmsDecorateModuleCategories?.[0]
        const json = lmsDecorateModuleCategories?.datas?.[0]?.json
        try {
          const parsed = json ? (JSON.parse(json) as CommunityRecord[]) : []
          communityDataMap[item.id] = parsed
        } catch (error) {
          console.log(error)
          communityDataMap[item.id] = []
        }
        if (item.isFeedStream === 1 && !feedCommunityModuleId) {
          feedCommunityModuleId = item.id
          feedCommunitySort = lmsDecorateModuleCategories?.dataShowRule || 0
          feedCommunityBoardIds = (lmsDecorateModuleCategories?.dataJumpIds || [])
            .map((id) => parseInt(String(id).trim(), 10))
            .filter((id) => Number.isFinite(id))
        }
      }
    }
    if (feedCommunityModuleId) {
      finished.value = false
    }
  }
}

const collegeList = ref<College[]>([])
const authStore = useAuthStore()
const { userId } = storeToRefs(authStore)

const bootstrapHome = async (loadingType?: '0' | '1') => {
  if (rateLimited.value) return
  collegeIdCache.value = collegeId.value

  const shouldCallAdvertise = localStorage.getItem('fromLogin')
  if (shouldCallAdvertise && shouldCallAdvertise === 'true') {
    getAdvertise()
  }

  const { code, data } = await postCollegeList()
  if (code === 429) {
    setRateLimited(true)
    return
  }
  if (code === 1) {
    if (collegeId.value === '-1') {
      collegeIdCache.value = data.colleges[0]?.id
    }
    collegeList.value = data.colleges
    onRefresh(loadingType)
  }
}

const handleRetry = async () => {
  setRateLimited(false)
  proxy?.$bus.emit('home_rate_limit_retry')
  await bootstrapHome('1')
}

watch(
  userId,
  async (newUserId, oldUserId) => {
    console.log(newUserId, oldUserId, userId, '============')
    await bootstrapHome()
  },
  {
    immediate: true
  }
)

const systemStore = useSystemStore()
const { lang } = storeToRefs(systemStore)
const { needConsent } = useCookieConsent()
watch([collegeIdCache, lang], () => {
  if (rateLimited.value) return
  onRefresh()
})

const themeColorWithAlpha = useThemeColorWithAlpha(0.6)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["home_container", { home_rate_limited: rateLimited.value }]),
    style: _normalizeStyle({ paddingTop: _unref(needConsent) ? '0' : '44px' })
  }, [
    (rateLimited.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            class: "rate_limit_img",
            src: _unref(rateLimitImg)
          }, null, 8, _hoisted_2),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('当前使用人数过多,请稍后再试')), 1),
          _createElementVNode("button", {
            class: "rate_limit_btn",
            onClick: handleRetry
          }, _toDisplayString(_ctx.$t('重试')), 1)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(HomeHeader, {
            collegeDetail: collegeDetail.value,
            collegeList: collegeList.value,
            onSetIdHandle: setCollegeIdCache
          }, null, 8, ["collegeDetail", "collegeList"]),
          _createVNode(PullToRefresh, {
            modelValue: refreshing.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
            onRefresh: _cache[2] || (_cache[2] = ($event: any) => (onRefresh('0')))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(List), {
                loading: loading.value,
                "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
                finished: finished.value,
                onLoad: onLoad
              }, {
                loading: _withCtx(() => [
                  _createVNode(_unref(Loading), { size: "20" })
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modules.value, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (item.code === 'app-banner')
                        ? (_openBlock(), _createBlock(Banner, {
                            key: 0,
                            data: item
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true),
                      (item.code === 'app-nav')
                        ? (_openBlock(), _createBlock(Menu, {
                            key: 1,
                            data: item,
                            badgeNum: badgeNum.value
                          }, null, 8, ["data", "badgeNum"]))
                        : _createCommentVNode("", true),
                      (item.code === 'app-notice')
                        ? (_openBlock(), _createBlock(Announcement, {
                            key: 2,
                            data: item
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true),
                      (item.code === 'app-learn-task')
                        ? (_openBlock(), _createBlock(TodoList, {
                            key: 3,
                            data: item,
                            badgeNum: badgeNum.value
                          }, null, 8, ["data", "badgeNum"]))
                        : _createCommentVNode("", true),
                      (item.code === 'app-live-stream')
                        ? (_openBlock(), _createBlock(LiveStream, {
                            key: 4,
                            data: item
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true),
                      (item.code === 'app-class')
                        ? (_openBlock(), _createBlock(Course, {
                            key: 5,
                            data: item
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true),
                      (item.code === 'app-category-class')
                        ? (_openBlock(), _createBlock(Course, {
                            key: 6,
                            data: item
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true),
                      (item.code === 'app-info')
                        ? (_openBlock(), _createBlock(Broadcast, {
                            key: 7,
                            data: item
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true),
                      (item.code === 'app-info-class')
                        ? (_openBlock(), _createBlock(BroadcastAndCourse, {
                            key: 8,
                            data: item
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true),
                      (item.code === 'app-multi-image')
                        ? (_openBlock(), _createBlock(Popularize, {
                            key: 9,
                            data: item
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true),
                      (item.code === 'app-community')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(CardTitle, {
                              title: item.title,
                              class: "community_title",
                              skipPage: "/community"
                            }, null, 8, ["title"]),
                            _createVNode(ArticleCard, {
                              articleData: getCommunityArticleData(item),
                              active: 0,
                              onShowPreview: showPreview
                            }, null, 8, ["articleData"])
                          ]))
                        : _createCommentVNode("", true),
                      (item.code === 'app-lecturer')
                        ? (_openBlock(), _createBlock(Instructor, {
                            key: 11,
                            data: item
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }, 8, ["loading", "finished"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(Advertise, {
            modelValue: advertiseShow.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((advertiseShow).value = $event)),
            data: advertiseList.value
          }, null, 8, ["modelValue", "data"]),
          _createVNode(BackTop, { bottom: "100px" }),
          _createVNode(ImgPreview, {
            imageList: imageList.value,
            previewIndex: previewIndex.value,
            previewShow: previewShow.value,
            onClosePreview: handleClose
          }, null, 8, ["imageList", "previewIndex", "previewShow"])
        ], 64))
  ], 6))
}
}

})